/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiErrorCatalog } from '../domain/core/api-error';

const AUTH_FAILURE_ERROR_NAMES = ['UserNotAuthenticatedError', 'AdAuthRepositoryError'];

const AUTH_FAILURE_INTERNAL_CODES = [815];

const UNAUTHORIZED_STATUS = 401;

export function extractInternalCode(error: unknown): number | undefined {
  const candidate = error as any;

  const internalCode =
    candidate?.error?.error?.internalCode ??
    candidate?.error?.internalCode ??
    candidate?.body?.error?.internalCode ??
    candidate?.internalCode;

  return typeof internalCode === 'number' ? internalCode : undefined;
}

export function isUnauthenticatedError(error: unknown): boolean {
  const candidate = error as any;

  if (candidate?.status === UNAUTHORIZED_STATUS) {
    return true;
  }

  if (AUTH_FAILURE_ERROR_NAMES.includes(ApiErrorCatalog.nameOf(error) as string)) {
    return true;
  }

  const internalCode = extractInternalCode(error);

  return internalCode !== undefined && AUTH_FAILURE_INTERNAL_CODES.includes(internalCode);
}
